import { BACKEND_ROUTES } from "../../backendRoutes";
import { useIsBasicRole } from "../useIsBasicRole";
import useSWR from "swr";

export function useUsers() {
    const isBasicRole = useIsBasicRole();

    return useSWR(isBasicRole ? null : `${BACKEND_ROUTES.USER}?sort=firstName`);
}
